// extracted by mini-css-extract-plugin
module.exports = {"root":"UserPopoverOverviewContainer-root-32L3G"};